<template>
  <div 
    :class="baseFlagClasses" 
    class="base-flag"
  >
    <img
      :src="require(`../../../assets/images/flags/${formattedCountry}.svg`)"
    >
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  country: {
    type: String,
    default: "dk",
  },
});

const centeredCountries = [
  "ad",
  "af",
  "ai",
  "al",
  "aq",
  "ar",
  "az",
  "bb",
  "be",
  "bf",
  "bi",
  "bn",
  "bo",
  "br",
  "bt",
  "ca",
  "ci",
  "ch",
  "cv",
  "cy",
  "dd",
  "dz",
  "ea",
  "ec",
  "eg",
  "et",
  "fr",
  "gb",
  "gc",
  "gd",
  "ge",
  "gf",
  "gg",
  "gh",
  "gi",
  "gn",
  "gp",
  "gt",
  "gu",
  "hk",
  "hn",
  "hr",
  "ht",
  "ie",
  "il",
  "im",
  "in",
  "iq",
  "ir",
  "it",
  "jm",
  "jp",
  "ke",
  "kg",
  "kh",
  "kr",
  "la",
  "lb",
  "lc",
  "ls",
  "ma",
  "md",
  "me",
  "mk",
  "ml",
  "mm",
  "mo",
  "mr",
  "mv",
  "mx",
  "ne",
  "ng",
  "ni",
  "pa",
  "pe",
  "ro",
  "sa",
  "sn",
  "sv",
  "sz",
  "td",
  "tj",
  "tn",
  "tr",
  "tt",
  "tz",
  "ug",
  "us",
  "va",
  "ve",
  "vn",
  "wi",
  "wo",
  "za",
];

const baseFlagClasses = computed(() => ({
  "base-flag--justify-center": centeredCountries.includes(
    (props.country || "").toLowerCase()
  ),
}));

const formattedCountry = computed(() => (props.country || "").toLowerCase());
</script>

<style lang="scss" scoped>
@import "./base-flag.scss";
</style>
